import React, { useState, useEffect } from 'react';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { href: '#instalacio', label: 'Instal·lacio' },
    { href: '#que-es-git', label: 'Git vs GitHub' },
    { href: '#workflow', label: 'Workflow' },
    { href: '#primer-repo', label: 'Primer Repo' },
    { href: '#comandos', label: 'Comandes' },
    { href: '#branching', label: 'Branching' },
    { href: '#github', label: 'Col·laboracio' },
    { href: '#recetari', label: 'Que faig si...?' },
    { href: '#videos', label: 'Videos' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <a href="#hero" className="navbar-brand">
          <img src={`${process.env.PUBLIC_URL}/lasalle_logo.JPG`} alt="La Salle Tarragona" className="navbar-logo" />
          <span className="navbar-title">Git & GitHub</span>
        </a>
        <button className={`navbar-toggle ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </button>
        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {links.map(link => (
            <li key={link.href}>
              <a href={link.href} onClick={() => setMenuOpen(false)}>{link.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
